import type { Tutorial } from '../types/project'

/** Shown on every project — how to use the shared tooling. */
export const tutorials: Tutorial[] = [
  {
    id: 'attio-101',
    name: 'Attio 101',
    description: 'Introduction to records, lists, views and pipelines in Attio.',
    url: 'https://attio.com/help/reference/attio-101/introduction',
    source: 'attio.com',
  },
  {
    id: 'apollo-academy',
    name: 'Apollo Academy',
    description: 'Courses on prospecting, sequences and using Apollo data well.',
    url: 'https://www.apollo.io/academy',
    source: 'apollo.io',
  },
]
